import { render, staticRenderFns } from "./ALFFooter.vue?vue&type=template&id=78921f44"
import script from "./ALFFooter.vue?vue&type=script&lang=js"
export * from "./ALFFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports